import IsServerSideRendering from './IsServerSideRendering';
import Cookie from '../services/Cookie';

const formatDateTime = (date, time) => {
  const dateString = `${date} ${time} EST`;
  const dateTime = new Date(dateString);
  return dateTime;
};

export function isWithinDateRange(dateRange) {
  if (!dateRange || dateRange.startDate === '' || dateRange.endDate === '') {
    return true;
  }

  const currentDate = new Date();

  const startTime = dateRange.startTime ? dateRange.startTime : '00:00';
  const startDate = formatDateTime(dateRange.startDate, startTime);
  const isAfterStartDate = currentDate.valueOf() >= startDate.valueOf();

  const endTime = dateRange.endTime ? dateRange.endTime : '23:59';
  const endDate = formatDateTime(dateRange.endDate, endTime);
  const isBeforeEndState = currentDate.valueOf() <= endDate.valueOf();

  const isWithinStartAndEndDate = isAfterStartDate && isBeforeEndState;
  return isWithinStartAndEndDate;
}

export const getShouldShowCovid19Banner = () => {
  const covid19IncludedPages = ['^/remove-me$'];
  const covid19ExcludedPages = [];
  return shouldDisplayOnPage(covid19IncludedPages, covid19ExcludedPages);
};

export function shouldDisplayOnPage(includedPages = [], excludedPages = []) {
  const currentPage = window.location.pathname;

  const includeAllPages = includedPages.length === 0;
  const isCurrentPageIncluded = includedPages.some(pattern => {
    const regex = new RegExp(pattern);
    return regex.test(currentPage);
  });
  const isIncluded = includeAllPages || isCurrentPageIncluded;

  const isExcluded = excludedPages.some(pattern => {
    const regex = new RegExp(pattern);
    return regex.test(currentPage);
  });

  const shouldDisplayOnCurrentPage = isIncluded && !isExcluded;
  return shouldDisplayOnCurrentPage;
}

export function setHasDismissedCookie(cookieName) {
  Cookie.setCookie(cookieName,'true');
}

export function checkIfDismissedCookieExists(cookieName) {
  const cookieVals = document.cookie.split(';');
  const cookie = cookieVals.filter(item => item.includes(`${cookieName}=`));
  if (!cookie.length) {
    return false;
  }
  return cookie;
}

export const closeModal = (cookieName, callback = () => {}, shouldIgnoreCookie) => {
  if (!shouldIgnoreCookie) {
    setHasDismissedCookie(cookieName);
  }
  callback();
};

export default {
  isWithinDateRange,
  setHasDismissedCookie,
  checkIfDismissedCookieExists,
  closeModal
};
